// 1_utils/raventic_config.js
// Per-language, NON-string Raventic config (API keys, locale, currency, search URLs) for
// the search widgets. The UI *strings* live in 0_global/translations.js; this holds the
// per-mutation config that isn't translatable. Consumed by the two 2_components setup
// files via window.NAT.raventic[window.NAT.lang] (falling back to cs).
//
// TODO per language mutation: replace the SK / PL placeholder API keys and URLs below with
// the real values from Raventic and the live mutation domains.

window.NAT = window.NAT || {};

window.NAT.raventic = window.NAT.raventic || {
	cs: {
		apiKey: "eucbf8ea240ae5a52ce1399a8df2bbd",
		bestsellersApiKey: "eucbf8ea240ae5a52ce1399a8df2bbd",
		locale: "cs-CZ",
		currency: "CZK",
		priceDecimals: 0,
		// Dropdown: where Enter / the "show all" button submits the query.
		submitUrl: "https://www.natios.cz/vyhledavani/",
		// Results: substring the page URL must contain for the results widget to run.
		resultsUrlMatch: "www.natios.cz/vyhledavani",
	},
	sk: {
		apiKey: "euce9d768f6d8930a3f221e4daeec91",
		bestsellersApiKey: "euce9d768f6d8930a3f221e4daeec91",
		locale: "sk-SK",
		currency: "EUR",
		priceDecimals: 2,
		submitUrl: "https://www.natios.sk/vyhladavanie/",
		resultsUrlMatch: "www.natios.sk/vyhladavanie",
	},
	pl: {
		apiKey: "REPLACE_WITH_PL_API_KEY",
		bestsellersApiKey: "REPLACE_WITH_PL_BESTSELLERS_API_KEY",
		locale: "pl-PL",
		currency: "PLN",
		priceDecimals: 2,
		submitUrl: "REPLACE_WITH_PL_SUBMIT_URL",
		resultsUrlMatch: "REPLACE_WITH_PL_RESULTS_URL_MATCH",
	},
};

const SEARCH_PATH_BY_LANG = {
	cs: "/vyhledavani/",
	sk: "/vyhladavanie/",
};

const host = location.hostname;
const isCloneOrLocal =
	host === "localhost" ||
	host === "127.0.0.1" ||
	host.endsWith(".myshoptet.com") ||
	host.startsWith("local.");

if (isCloneOrLocal) {
	Object.entries(SEARCH_PATH_BY_LANG).forEach(function ([lang, path]) {
		const config = window.NAT.raventic[lang];
		if (!config) return;
		config.submitUrl = location.origin + path;
		config.resultsUrlMatch = path.slice(0, -1);
	});
}
